var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDropdown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 12,
    viewBox: "0 0 21 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4986 7.5931L17.1611 0.9306C17.4743 0.617405 17.8729 0.460808 18.357 0.460808C18.841 0.460808 19.2396 0.617405 19.5528 0.9306C19.866 1.24379 20.0226 1.64241 20.0226 2.12643C20.0226 2.61046 19.866 3.00907 19.5528 3.32227L11.6945 11.1806C11.5236 11.3514 11.3386 11.4724 11.1392 11.5436C10.9399 11.6148 10.7264 11.6504 10.4986 11.6504C10.2708 11.6504 10.0573 11.6148 9.858 11.5436C9.65869 11.4724 9.47362 11.3514 9.30279 11.1806L1.44446 3.32226C1.13126 3.00907 0.974667 2.61046 0.974667 2.12643C0.974667 1.6424 1.13126 1.24379 1.44446 0.930599C1.75765 0.617403 2.15626 0.460806 2.64029 0.460806C3.12432 0.460806 3.52293 0.617403 3.83613 0.930599L10.4986 7.5931Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.a48bd882c665bd9b69c17d0f1ede44dc.svg";
export { ForwardRef as ReactComponent };